import React from "react";
import "./slideInModal.scss";

const SlideInModal = ({ isOpen, onClose, children }) => {
  return (
    <div className={`slide-in-modal ${isOpen ? "open" : ""}`}>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default SlideInModal;
